shadow$provide[3] = function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.useThreestrap = void 0;
var react_1 = require("react");
var ThreestrapContext = (0, react_1.createContext)(null);
exports["default"] = ThreestrapContext;
var useThreestrap = function () {
    var threestrap = (0, react_1.useContext)(ThreestrapContext);
    if (!threestrap) {
        throw new Error("Threestrap context is not available");
    }
    return threestrap;
};
exports.useThreestrap = useThreestrap;
//# sourceMappingURL=ThreestrapContext.js.map
};